import { __assign, __decorate, __extends, __metadata } from "tslib";
import * as React from 'react';
import { BindPropsHelper } from '../PropTypes';
import { Model, Utils } from '@singularsystems/neo-core';
import { observer } from 'mobx-react';
import { InputHelpers } from '../InputHelpers';
import { DropDownBase } from './DropDownBase';
import { FormContext } from '../FormContext';
var DropDown = /** @class */ (function (_super) {
    __extends(DropDown, _super);
    function DropDown(props) {
        var _this = _super.call(this, props) || this;
        _this.listIndexSymbol = Symbol("ValueIndex");
        _this.onItemSelected = _this.onItemSelected.bind(_this);
        _this.fieldInfoContainer = Model.ModelFieldInfo.asModelFieldInfoContainer(_this.props.bind.attachedTo);
        return _this;
    }
    Object.defineProperty(DropDown.prototype, "items", {
        get: function () {
            var _this = this;
            var _a;
            var items = this.getItems((_a = this.props.select.items) !== null && _a !== void 0 ? _a : this.props.select.itemSource);
            if (items && items.length > 0) {
                var item = items[0];
                this.findMembers(item);
            }
            if (this.props.select.filterPredicate !== undefined) {
                return items.filter(function (item) { return _this.props.bind.value === item[_this.valueMember] || _this.props.select.filterPredicate(item); });
            }
            else {
                return items;
            }
        },
        enumerable: false,
        configurable: true
    });
    DropDown.prototype.createLookupIndex = function (list) {
        var _this = this;
        var index = {};
        //@ts-ignore
        list[this.listIndexSymbol] = index;
        list.forEach(function (item) { return index[item[_this.valueMember]] = item; });
        return index;
    };
    DropDown.prototype.getSelectedOption = function (value) {
        if (!this.sortByValue) {
            this.props.bind.propertyInfo.hasSortValue = true;
        }
        if (!this.selectedItem || this.selectedItem[this.valueMember] != value) {
            var list = this.items;
            //@ts-ignore
            var index = list[this.listIndexSymbol];
            var indexJustCreated = false;
            if (!index) {
                index = this.createLookupIndex(list);
                indexJustCreated = true;
            }
            this.selectedItem = index[value];
            if (value && !this.selectedItem && !indexJustCreated) {
                // Index may be out of date.
                index = this.createLookupIndex(list);
                this.selectedItem = index[value];
            }
            if (!this.selectedItem) {
                // create default item.
                this.selectedItem = {};
                this.selectedItem[this.displayMember] = "";
                this.selectedItem[this.valueMember] = null;
            }
            var displayValue = this.selectedItem[this.displayMember];
            this.setFieldInfo(this.props.bind, displayValue);
            this.props.bind.sortValue = this.sortByValue ? value : displayValue;
        }
        return this.selectedItem;
    };
    DropDown.prototype.onItemSelected = function (e) {
        this.selectedItem = null;
        var boundItem = this.getSelectedOption(e.target.value);
        if (boundItem && boundItem[this.valueMember] !== undefined) {
            // Use the bound item to get the correct data type of the value member;
            this.props.bind.value = boundItem[this.valueMember];
        }
        else {
            this.props.bind.value = e.target.value;
        }
        if (this.props.select.onItemSelected !== undefined) {
            this.props.select.onItemSelected((boundItem[this.valueMember] === undefined ? undefined : boundItem));
        }
    };
    DropDown.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var splitProps = BindPropsHelper.normaliseEditorProps(this, this.props);
        var domProps = BindPropsHelper.autoSetDomProperties(splitProps, this.context);
        domProps.className = Utils.joinWithSpaces(domProps.className, splitProps.isBootstrap ? "form-control" : "neo-forms-editor");
        this.sortByValue = (_a = splitProps.select) === null || _a === void 0 ? void 0 : _a.sortByValue;
        if (splitProps.select) {
            if (splitProps.select.valueMember)
                this.valueMember = splitProps.select.valueMember;
            if (splitProps.select.displayMember)
                this.displayMember = splitProps.select.displayMember;
        }
        var displayInfo = this.props.bind.validator.getDisplayState(this.context.validationDisplayMode);
        displayInfo.applyToDom(domProps, !splitProps.inGroup);
        var items = this.items;
        var selectedItem = this.getSelectedOption(this.props.bind.value); // This sets the sort value to allow sorting of drop downs in grids. 
        var value = this.props.bind.value;
        var notFound = items.length > 0 && value && selectedItem[this.valueMember] !== value;
        var addBlankItem = ((_c = (_b = splitProps.select) === null || _b === void 0 ? void 0 : _b.allowNulls) !== null && _c !== void 0 ? _c : this.props.bind.propertyInfo.allowNulls) || !value || notFound;
        if (addBlankItem && items.find(function (item) { return item[_this.valueMember] === null || item[_this.valueMember] === ""; })) {
            // If there is an item with a null value, don't add a blank drop down item.
            addBlankItem = false;
        }
        var control;
        if (this.isLoading) {
            control = React.createElement("div", { className: "form-control form-control-loading" },
                React.createElement("div", { className: "spinner-border" }));
        }
        else if ((_d = splitProps.select) === null || _d === void 0 ? void 0 : _d.renderAsText) {
            control = React.createElement("span", null, selectedItem ? selectedItem[this.displayMember] : "");
        }
        else if (splitProps.editor.isReadOnly) {
            control = React.createElement("input", __assign({ type: "text", value: selectedItem ? selectedItem[this.displayMember] : "", ref: splitProps.editor.inputElement }, domProps));
        }
        else {
            if (domProps.readOnly) {
                domProps.disabled = true;
            }
            var valueIsBlank = value === undefined || value === null;
            var nullText = (valueIsBlank || ((_e = splitProps.select) === null || _e === void 0 ? void 0 : _e.deSelectText) === undefined) ? (_f = splitProps.select) === null || _f === void 0 ? void 0 : _f.nullText : (_g = splitProps.select) === null || _g === void 0 ? void 0 : _g.deSelectText;
            if (valueIsBlank) {
                domProps.className = Utils.joinWithSpaces(domProps.className, "select-no-value");
            }
            control =
                React.createElement("select", __assign({ value: valueIsBlank ? "" : value, onChange: this.onItemSelected, ref: splitProps.editor.inputElement }, domProps),
                    addBlankItem && React.createElement("option", { className: "option-default" }, notFound ? "(Not found): ".concat(value) : nullText),
                    items.map(function (item) { return (React.createElement("option", { value: item[_this.valueMember], key: item[_this.valueMember] }, item[_this.displayMember])); }));
        }
        return (InputHelpers.surroundWithInputGroup(control, splitProps.editor));
    };
    DropDown.contextType = FormContext;
    DropDown = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], DropDown);
    return DropDown;
}(DropDownBase));
export default DropDown;
